import { Regions } from './region';

/** Фичетогл акции «30 000 ₽ за покупку квартиры» */
export const NEWBUILDING_PURCHASE_GIFT_ENABLED_KEY = 'Newbuilding.PurchaseGiftPromo.Enabled';
/** Почта, на которую покупатель присылает письмо для участия в акции */
export const NEWBUILDING_PURCHASE_GIFT_EMAIL_KEY = 'Newbuilding.PurchaseGiftPromo.Email';
/** Ссылка на страницу условий акции */
export const NEWBUILDING_PURCHASE_GIFT_TERMS_URL_KEY = 'Newbuilding.PurchaseGiftPromo.TermsUrl';

/** Регионы, в которых показываются точки входа акции */
export const NEWBUILDING_PURCHASE_GIFT_REGIONS: number[] = [
  Regions.Moscow,
  Regions.MoscowArea,
  Regions.Spb,
  Regions.SpbArea,
];

// TODO: HBC-1800 подтвердить финальный текст у дизайнера (в десктопном макете «Текст на согласовании»)
export const NEWBUILDING_PURCHASE_GIFT_ENTRY_POINT_TEXT = 'Купите квартиру и получите 30 000 ₽';
export const NEWBUILDING_PURCHASE_GIFT_SLIDE_BUTTON_TEXT = 'Подробнее';
